import moment from 'moment-jalaali';

moment.loadPersian();

const formatDate = (date: Date, format?: string): any => moment.utc(date).local().format(format || 'jYYYY/jM/jD HH:mm:ss');

const formatDateFromNow = (date: Date): any => moment.utc(date).local().fromNow();

export { formatDate, formatDateFromNow };
